import * as React from 'react';
import { LinkTile } from '../../../Common/LinkTile';
import './style.css';

export interface IndexTileProps {
  className?: string;
  image: string;
  url: string;
}

export interface IndexTileState {
  /* empty*/
}

export class IndexTile extends React.Component<IndexTileProps, IndexTileState> {
  render() {
    const { className, image, url } = this.props;

    return (
      <LinkTile className={'index-tile ' + className} image={image} url={url}>
        {this.props.children}
      </LinkTile>
    );
  }
}

export default IndexTile;



// WEBPACK FOOTER //
// ./src/app/components/CategoryIndex/CategoryTiles/IndexTile/index.tsx